import { fmtBRL } from "@/lib/api";
import { CheckCircle } from "@phosphor-icons/react";

export default function PayBillModal({ showPay, setShowPay, onSubmit }) {
  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-6" onClick={() => setShowPay(null)}>
      <div className="glass max-w-md w-full p-8" onClick={(e) => e.stopPropagation()} data-testid="pay-modal">
        <div className="overline text-zinc-500 mb-2">REGISTRAR PAGAMENTO</div>
        <h2 className="font-head text-2xl font-bold mb-1">{showPay.bill.supplier_name}</h2>
        <p className="text-sm text-zinc-500 mb-6">Valor: <span className="font-mono font-bold text-black">{fmtBRL(showPay.bill.amount)}</span> · Vencimento: {new Date(showPay.bill.due_date + "T12:00:00").toLocaleDateString("pt-BR")}</p>
        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="label">Data do Pagamento</label>
            <input type="date" className="input font-mono" required value={showPay.form.paid_date} onChange={(e) => setShowPay({ ...showPay, form: { ...showPay.form, paid_date: e.target.value } })} data-testid="pay-date" />
          </div>
          <div>
            <label className="label">Forma Real de Pagamento</label>
            <select className="input" value={showPay.form.payment_method} onChange={(e) => setShowPay({ ...showPay, form: { ...showPay.form, payment_method: e.target.value } })} data-testid="pay-method">
              <option value="boleto">Boleto</option>
              <option value="pix">PIX</option>
              <option value="cartao">Cartão</option>
              <option value="dinheiro">Dinheiro</option>
            </select>
          </div>
          <div>
            <label className="label">Observação</label>
            <textarea className="input min-h-[50px]" value={showPay.form.notes} onChange={(e) => setShowPay({ ...showPay, form: { ...showPay.form, notes: e.target.value } })} />
          </div>
          <div className="flex gap-3 pt-2">
            <button type="button" className="btn btn-ghost flex-1" onClick={() => setShowPay(null)}>Cancelar</button>
            <button type="submit" className="btn flex-1" data-testid="pay-save"><CheckCircle size={16} weight="bold" /> Confirmar Pagamento</button>
          </div>
        </form>
      </div>
    </div>
  );
}
